import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useForm } from 'react-hook-form'
import { getPost, postNewForm, updateForm } from '../../../../service';

import { Flex, Heading, FormErrorMessage,  FormLabel,  FormControl,  Input,  Button, Box, Textarea } from '@chakra-ui/react';
import AdminLayout from '../../Layout';
import FieldGroups from '../FormBuilderNew/FieldGroups';

type Props = {
  params: any;
};

function FormBuilderEdit({ params }: Props) {

  const { isLoading, error, data } = useQuery('getPost', () => getPost(params.form_id));

  const [fieldGroups, setFieldGroups] = useState([] as any);

  const mutation = useMutation(data => {
    return updateForm(data);
  }, {
    onSuccess: () => {
      alert('양식을 저장했습니다.');
    }
  });

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    setValue
  } = useForm();

  useEffect(() => {
    if (data === undefined) {
      return;
    }
    setValue('post_title', data.title);
    setFieldGroups(JSON.parse(data.meta.form_formsettings));
  }, [data])

  function onSubmit(values:any) {
    const editedForm = {
      ID: data.id,
      ...values,
      post_type: 'form',
      post_status: 'private',
      meta: {
        form_formsettings: JSON.stringify(fieldGroups),
      }
    }
    
    mutation.mutate(editedForm);
  }

  const onUpdateFieldGroups = (list:any[]) => {		
    setFieldGroups(list);
  }

  return (
    <AdminLayout>
      { !isLoading && data && (
        <Flex justify="space-between">
          <Box w="30%">
            <Heading size="xl" pb="5">양식 편집</Heading>
            <form name="newForm" onSubmit={handleSubmit(onSubmit)}>
              <FormControl isInvalid={errors.name}>
                <FormLabel htmlFor='post_title'>양식 제목</FormLabel>
                <Input
                  id='post_title'
                  placeholder='양식 제목'
                  {...register('post_title', { required: true })}
                  readOnly
                />
                <FormErrorMessage>
                  {errors.name && errors.name.message}
                </FormErrorMessage>
              </FormControl>

              {/* <FormControl isInvalid={errors.name} mt="2">
                <FormLabel htmlFor='post_title'>설명</FormLabel>
                <Textarea
                  id='post_description'
                  placeholder='설명'
                  {...register('post_description', { required: true })}
                />
                <FormErrorMessage>
                  {errors.name && errors.name.message}
                </FormErrorMessage>
              </FormControl> */}

              <Button mt={4} colorScheme='dgr' isLoading={isSubmitting} type='submit'>
                저장하기
              </Button>
            </form>
          </Box>
          {
            fieldGroups.length > 0 && (
              <Box w="65%">
                <FieldGroups fieldGroups={fieldGroups} onUpdateFieldGroups={onUpdateFieldGroups} />
              </Box>
            )
          }
        </Flex>
      )
      }
    </AdminLayout>
  );
}

FormBuilderEdit.defaultProps = {
};

export default FormBuilderEdit;